setUserEmailAvailability